import { EdiFuncAck } from "../EdiFuncAck";
import { EdiMapErrors } from "../EdiMapErrors";
import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutViewEdiBalanceDue extends Layout {
    buttonEdit: Button;
    buttonExpand: Button;
    buttonExpandCharges: Button;
    buttonExpandTaxes: Button;
    buttonOpenInvoice: Button;
    buttonRawData: Button;
    buttonReload: Button;
    checkBalanceDue: Checkbox;
    checkRebill: Checkbox;
    checkboxIntercompany: Checkbox;
    checkboxLockMiles: Checkbox;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacerForEdiBilling: HorizontalSpacer;
    label2: Label;
    labelAdditionalCharges: Label;
    labelAutoRated: Label;
    labelBalanceDue: Label;
    labelEditWarning: Label;
    labelExciseTaxTotalLabel: Label;
    labelFuncAck: Label;
    labelRates: Label;
    labelTaxCharges: Label;
    layoutEdiFunctionalAck: EdiFuncAck;
    layoutMapErrors: EdiMapErrors;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel14: Panel;
    panelAdditionalCharges: Panel;
    panelBalanceDue: Panel;
    panelButtons: Panel;
    panelCollapsible: Panel;
    panelEdiBilling: Panel;
    panelFuncAck: Panel;
    panelMain: Panel;
    panelOtherChargeTable: Panel;
    panelOtherChargesHeader2: Panel;
    panelRates: Panel;
    panelTaxChargeTable: Panel;
    panelTaxChargesHeader: Panel;
    panelTaxes: Panel;
    sourceEdiBilling: DataSource;
    sourceEdiFunctionalAck: DataSource;
    sourceEdiMapError: DataSource;
    sourceExcisetaxChargeEdi: DataSource;
    sourceOtherChargeEdi: DataSource;
    switchTransmit: Switch;
    tabErrors: Tab;
    tableOtherCharges: Table;
    tableTaxCharges: Table;
    tabsetErrors: Tabset;
    textPartnerId: Textbox;
    textReadyToSend: Textbox;
    textboxBlnum: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityDescr: Textbox;
    textboxConsigneeRefNo: Textbox;
    textboxLinehaulChg: Textbox;
    textboxMinimumWeight: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPieces: Textbox;
    textboxRate: Textbox;
    textboxRateType: Textbox;
    textboxRatingUnits: Textbox;
    textboxTransmitted: Textbox;
    textboxWeight: Textbox;
    txtBatch: Textbox;
    txtCorrectionIndicator: Textbox;
    txtCreateDate: Textbox;
    txtDirection: Textbox;
    txtError: Textbox;
    txtId: Textbox;
    txtModifiedDate: Textbox;
    txtModifiedUser: Textbox;
    txtServiceCode: Textbox;
    txtShipmentId: Textbox;
}
